import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
export function FinalCTASection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.15
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 20
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="relative w-full bg-brand-bg py-24 md:py-32 px-6 overflow-hidden" data-id="element-127">
      {/* Subtle background glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-brand-green/5 rounded-full blur-[120px] pointer-events-none" data-id="element-128" />

      <div className="relative max-w-4xl mx-auto text-center" data-id="element-129">
        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.2
      }} className="flex flex-col items-center" data-id="element-130">
          <motion.h2 variants={itemVariants} className="text-3xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight" data-id="element-131">
            Empezá hoy y construí tu negocio online paso a paso
          </motion.h2>

          <motion.p variants={itemVariants} className="text-lg md:text-xl text-brand-dark/70 mb-12 max-w-2xl" data-id="element-132">
            Sin experiencia, sin complicarte y con un método probado.
          </motion.p>

          <motion.div variants={itemVariants} className="mb-8" data-id="element-133">
            <span className="inline-block px-6 py-2 rounded-full bg-brand-card border border-brand-green/20 text-brand-green text-xl md:text-2xl font-bold shadow-[0_0_15px_rgba(20,184,166,0.1)]" data-id="element-134">
              Acceso completo hoy por solo $49.900
            </span>
          </motion.div>

          <motion.a variants={itemVariants} href="https://www.emprende-digital.com/cart/51742249156888:1" target="_blank" rel="noopener noreferrer" className="group relative inline-flex items-center justify-center px-10 py-5 text-xl font-bold text-brand-bg bg-brand-green rounded-full transition-all duration-300 hover:bg-brand-green-hover hover:scale-105 hover:-translate-y-1 shadow-[0_0_30px_rgba(20,184,166,0.3)] hover:shadow-[0_0_50px_rgba(20,184,166,0.5)] mb-12" data-id="element-135">
            <span className="mr-2 text-2xl group-hover:animate-bounce" data-id="element-136">🔥</span>
            Empezar Ahora
          </motion.a>

          <motion.div variants={itemVariants} className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 mb-10" data-id="element-137">
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-138">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-139" />
              <span data-id="element-140">Acceso inmediato</span>
            </div>
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-141">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-142" />
              <span data-id="element-143">Pago 100% seguro con Mercado Pago</span>
            </div>
            <div className="flex items-center text-brand-dark/60 text-sm md:text-base" data-id="element-144">
              <CheckIcon className="w-5 h-5 text-brand-green mr-2" data-id="element-145" />
              <span data-id="element-146">Empezá hoy mismo</span>
            </div>
          </motion.div>

          <motion.p variants={itemVariants} className="text-xs md:text-sm text-brand-dark/40 uppercase tracking-widest font-medium" data-id="element-147">
            Acceso disponible por tiempo limitado
          </motion.p>
        </motion.div>
      </div>
    </section>;
}